module.exports = __webpack_public_path__ + "img/ic_representative_business_industries.1e93d83e.svg";